// API configuration and base service
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SIAN_DOMAIN = process.env.REACT_APP_SIAN_DOMAIN;

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.sianDomain = SIAN_DOMAIN;
  }

  async makeRequest(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    };

    const requestOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers,
      },
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();

      if (!response.ok) {
        // En lugar de hacer throw, devolver la respuesta completa del error
        console.log('API Error Response:', data);
        return {
          success: false,
          message: data.message || `HTTP error! status: ${response.status}`,
          error: data.error || data, // Preservar la estructura completa del error
          status: response.status,
        };
      }

      return {
        success: true,
        data: data,
        status: response.status,
      };
    } catch (error) {
      console.error('API Request Error:', error);

      // Si es un error de parsing JSON, intentar obtener la respuesta como texto
      if (error instanceof SyntaxError) {
        return {
          success: false,
          error: 'Invalid JSON response from server',
          status: 500,
        };
      }

      return {
        success: false,
        error: error.message,
        status: error.status || 500,
      };
    }
  }

  // GET request
  async get(endpoint, headers = {}) {
    return this.makeRequest(endpoint, {
      method: 'GET',
      headers,
    });
  }

  // POST request
  async post(endpoint, data = {}, headers = {}) {
    return this.makeRequest(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    });
  }

  // PUT request
  async put(endpoint, data = {}, headers = {}) {
    return this.makeRequest(endpoint, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    });
  }

  // DELETE request
  async delete(endpoint, headers = {}) {
    return this.makeRequest(endpoint, {
      method: 'DELETE',
      headers,
    });
  }
}

export default new ApiService();
